export default {
  fullname: '香港法律資訊中心',
  subheading: '免費提供有關香港法律的資訊網頁',
  lawtech: '由香港大學法律學院法律與科技研究中心設立',
  news_1_title: "歡迎使用 HKLII 的升級版網站",
  news_1_intro: "香港法律資訊中心 (HKLII)的升級版網站終於登場。如希望瞭解其新功能，請查看{0}。本站的新功能和改進之處包括：",
  news_1_content: [
    "你的寶貴意見有助我們精益求精, 請花一分鐘時間在網站右下角的{0}內評分，或填寫{1}。我們亦藉此機會感謝各位 Beta 測試的參與者，你們的評語和建議令 HKLII 變得更為實用。",
    "未來我們仍將勉力前行，務求將人工智慧技術整合到 HKLII 之中，提供免費且便於理解的法律資訊。我們十分感激各界對 HKLII 的捐助，並誠摯邀請您加入捐款者的行列，{0}我們的使命。所有捐款人均會在我們的網站上獲得{1}。"
  ],
  news_1_newfeature: [
    "可使用判例引文搜尋判決書",
    "Noteup 現已支援判例引",
    "擴大了使用通用編號及案件編號搜尋案件的範圍",
    "自動整合案件紀錄及上訴歷史",
    "條文定義的連結更加準確",
    "增加了簡體中文版的法例資料庫",
    "可快速連結至官方法例頁面 (e-Legislation)",
    "介面設計會自動適應各種設備(手機、桌上電腦)",
    "判案書及法例的版式更易於閱讀"
  ],
  news_1_subhead: [
    "意見及查詢",
    "支持智能 HKLII 的發展"
  ],
  news_1_donation: "支持",
  news_1_thankdonor: "銘謝",
  news_2_title: "Hong Kong Company Law Cases (HKCLC) 引述案例編號現已加入 HKLII",
  news_2_content: [
    "我們現在提供 HKCLC 引述案例編號。你將會在判案書左側「有關此判案書」一欄內的「判例引文」找到相關資訊。你亦能在搜尋欄裡輸入案例編號 (例: [2022] HKCLC 715) 直接搜尋判案書及有關引述。 ",
    "HKCLC 是一系列判例彙編，涵蓋香港公司法案件和涉及香港公司的海外公司法案件。"
  ],
  news_3_title: "HKLII 遷移通知",
  news_3_content: [
    "從 2023 年 6 月 16 日起，您將能夠通過 {0} 訪問 HKLII 的升級版本。你仍能通過 v2.hklii.hk 使用本網站。",
    "如果您想訪問舊版本的 HKLII，請使用 {0}。",
    "我們感謝您一直以來的支持，請將任何評論或問題發送到我們的 {0}。",
  ],
  news_4_title: "HKLII 現已引入 AI 驅動功能",
  news_4_intro: [
    "在過去兩年，HKLII 的研發團隊致力開發應用人工智能技術的新功能以增加法律研究的效率。我們已將研究成果應用到 HKLII 推出的新功能中。",
    "新增功能標將以 {0} 標籤識別。請注意以下功能只適用於英文判決書和搜尋。請訪問我們的{1}頁面以深入了解各種功能。新功能包括：",
    "我們亦設計了「{0}」，以圖像和統計工具幫助用家掌握歷年販毒和人身傷亡案件的數據。",
  ],
  news_4_content: [
    "我們想趁此機會感謝所有參與了 Beta 測試的用家。如果您對新功能有任何{0}或建議，請隨時與我們聯繫。",
    "感謝你使用 HKLII，我們期待為你提供更好的服務。",
  ],
  news_4_newfeature: [
    "智能搜尋分類和建議",
    "販毒及人身傷亡案件的案件資訊",
    "以標籤搜尋類似的人身傷亡案件",
    "人身傷亡案件概要",
  ],
  ratingbox: "評分框",
  feedbackfrom: "意見表格",
  feedbackpage: "反饋頁面",
  sitetour: "網站導覽",
  signoff: "HKLII 團隊",
  chi_signoff: "敬啟",
  donatecard_title: "請支持我們構建新一代 HKLII",
  donatecard_content: "HKLII 一直致力於讓人人可查閱法律。2020年，我們著手升級已有20年歷史的網站，令 HKLII 的介面與時並進，並添加了新功能以改善用戶的法律研究體驗。儘管疫情肆虐，我們並未停步。接下來，我們仍將勉力前行， 務求在免費提供法律資訊的同時開發更智慧功能。我們十分感激各界對HKLII的捐助，並誠摯邀請您加入捐款者的行列，{0}我們的使命。我們盼望在未來幾年內籌集一百萬元，將人工智慧技術整合到HKLII之中。",
  falm_intro:"HKLII 免費提供有關香港法律的資訊及參與法律信息自由取用運動。",
  advanced_desc: '指定類別和資料庫作針對性搜尋',
  simple_desc: '你可以在此使用搜尋運算子 (AND, NEAR, tax*, <br/> "moral rights", ... 等) 以尋找站內資料, 如: <li>法例章號 (599J)</li><li>判決書 (頸 NEAR 麻痺)</li><li>判例引文 ([2001] 1 HKLRD 1)</li><li>法律概念 (procedural impropriety)</li><li>人物 (Chief Justice AND Andrew Li)</li>',
  announcements: '最新消息',
  news: '最近上載的原訟法庭、上訴法庭及終審法院判案書',
  case_summary:'案件概要', //move to case?
  case_summary_desc:'快速查看判決書重點。注意此功能暫不支援中文判案書。',
  shortcut_hint:'本部分將在此設備保持打開（或關閉）',
  judgments: '判案書',
  judgments_altlang: '', //英文判案書
  legislation: '法例',
  copyright: '版權所有',
  crinfo: '香港法律資訊中心 (HKLII)',
  run_by: '營運',
  manage_by: '營運',
}
